import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {ticketApi} from "../services/ticketService";
import {useParams} from "react-router-dom";

export const useAddTicket = () => {
  const queryClient = useQueryClient();
  const {mutateAsync: add} = useMutation({
    mutationFn: ticketApi.add,
  });

  const onAddTicket = async ({
    title,
    description,
    categoryId,
    message,
    interventionId,
    files,
  }) => {
    try {
      // 1. Create ticket
      const newTicket = await add({
        body: {interventionId, title, categoryId},
      });
      queryClient.invalidateQueries({queryKey: ["tickets"]});

      // 2. Add message to the new ticket
      await onAddMessage({
        ticketID: newTicket.id,
        body: {description, files, message},
      });
    } catch (error) {
      throw error;
    }
  };

  const {mutateAsync: addMessage, isPending: isSendingMessage} = useMutation({
    mutationFn: ({id, body}) => ticketApi.addMessage({body}),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({queryKey: ["ticket"]});
      queryClient.invalidateQueries({queryKey: ["tickets"]});

      //
      // queryClient.invalidateQueries({
      //   queryKey: ["ticket", variables.id],
      //   exact: true,
      //   refetchType: "active",
      // });

      // queryClient.refetchQueries({
      //   queryKey: ["ticket", variables.id],
      //   type: "active",
      //   exact: true,
      // });
    },
  });

  const onAddMessage = ({ticketID, body}) => {
    const formData = new FormData();

    formData.append("ticketId", ticketID);

    const {description, file, message} = body;

    if (!!message) {
      formData.append("message", message);
    }
    if (!!description) {
      formData.append("message", description);
    }
    if (!!file) formData.append("ticketMessage", file);

    return addMessage({id: ticketID, body: formData});
  };

  return {
    onAddTicket,
    onAddMessage,
    isSendingMessage,
  };
};

export const useTickets = (user) => {
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["tickets", user?.id],
    queryFn: () =>
      ticketApi.getAll({
        body: {
          filter: {createdById: user?.id},
          order: [["updatedAt", "DESC"]],
        },
      }),
    select: (response) => {
      return response.rows;
    },
    enabled: !!user?.id,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useTicket = () => {
  const {id} = useParams();
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["ticket", id],
    queryFn: () => ticketApi.getOne({id}),
    select: (response) => {
      return response;
    },
    // enabled: !!id,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
